import { IA_CATEGORIES } from './iaCategories';

export const EVENT_STYLES = {
  circle:  { color: '#0077b6' },
  diamond: { color: '#e07b00' },
  ...Object.fromEntries(
    Object.values(IA_CATEGORIES).map(({ key, color }) => [key, { color }])
  ),
};
export const DEFAULT_EVENT_STYLE = { color: '#888888' };

export const SIGNAL_DOMAIN = [0, 0.84];
export const LABEL_DOMAIN  = [0.84, 1.0];
export const TOOLBAR_H     = 46;
export const SECTION_ALPHA = '28';

export const LABEL_TYPES = {
  IA: { iconType: 'circle', label: 'IA', color: '#0077b6' },
  JALON: { iconType: 'circle', label: 'Jalon', color: '#e07b00' },
};

export const COULEURS_PHASES = [
  '#e07b00',
  '#0077b6',
  '#26b36a',
  '#9b2226',
  '#6a0572',
  '#2f46d8',
  '#2d6a4f',
];

// Couleur réservée aux labels MANUEL (Jalon) — ne doit jamais être réutilisée ailleurs.
export const MANUAL_COLOR = '#e07b00';

// Palette pour l'attribution de couleurs uniques aux labels IA / autres.
// MANUAL_COLOR (#e07b00) est volontairement exclu pour rester exclusif aux Jalons.
export const LABEL_COLORS = [
  '#0077b6', '#26b36a', '#9b2226', '#6a0572',
  '#2f46d8', '#2d6a4f', '#c0392b', '#00838f', '#e91e63',
  '#5d4037', '#1565c0', '#558b2f', '#6a1b9a', '#bf360c',
  '#00695c', '#ad1457', '#283593', '#4e342e', '#37474f',
];
